import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import styled from "react-emotion";

import { MarkdownStringContent } from "../components/Content";
import { colors } from "../consts";
import MapSelector from "../components/MapSelector";

const Head = styled.div`
  padding-top: 200px;
  padding-bottom: 90px;
  display: flex;
  justify-content: center;
  background-color: ${colors.primaryLightest};
`;
const HeadContent = styled.div`
  width: 75vw;
  max-width: 1060px;
  min-width: 900px;
  display: flex;
`;
const HeadLeft = styled.div`
  flex: 0.45;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const SelectorWrapper = styled.div`
  margin-top: 30px;
`;
const HeadRight = styled(MarkdownStringContent)`
  flex: 0.55;
  margin-left: 60px;
`;
const About = styled.div`
  padding: 90px 0;
  display: flex;
  justify-content: center;
`;
const AboutContent = styled(MarkdownStringContent)`
  width: 50vw;
  max-width: 800px;
  min-width: 400px;
`;

export default class IndexPage extends React.Component {
  render() {
    const {
      data: {
        homeContent: { frontmatter: homeContent },
        mapSelectorItems: {
          frontmatter: { indicators }
        }
      }
    } = this.props;

    return (
      <React.Fragment>
        <Head>
          <HeadContent>
            <HeadLeft>
              <h1>{homeContent.title}</h1>
              <SelectorWrapper>
                <h5>
                  To view the map, select<br />a data point below:
                </h5>
              </SelectorWrapper>
              <MapSelector indicators={indicators} />
            </HeadLeft>
            <HeadRight content={homeContent.topBody} />
          </HeadContent>
        </Head>

        <About>
          <AboutContent content={homeContent.about} />
        </About>
      </React.Fragment>
    );
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object
  })
};

export const pageQuery = graphql`
  query IndexPageByPath {
    homeContent: markdownRemark(frontmatter: { path: { eq: "/" } }) {
      frontmatter {
        title
        topBody
        about
      }
    }
    mapSelectorItems: markdownRemark(frontmatter: { path: { eq: "/map" } }) {
      ...MapSelector
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js